import { render } from "./PricingStyleThree.vue?vue&type=template&id=ff26bc16&ts=true"
import script from "./PricingStyleThree.vue?vue&type=script&lang=ts"
export * from "./PricingStyleThree.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__